function calculateFuelDiff (a, b) {
  return b - a
}

function getRefuelingLiters (d, position, diff) {
  if (position.protocol === 'teltonika' && !position.attributes.io89) {
    return diff
  }
  return Math.round(diff * d.attributes.fuel_tank_capacity / 100)
}

function calculateConsumption (d, data) {
  let fuelConsumption = 0
  const withFuelUsed = data.route && data.route.find(p => p.attributes.fuelUsed)
  if (data.summary && withFuelUsed) {
    fuelConsumption = calculateSpentFuel(data.summary.spentFuel, d, withFuelUsed)
  } else if (data.trips && data.stops) {
    const spentFuel = data.trips.reduce((a, b) => a + (b.spentFuel > 0 ? b.spentFuel : 0), 0) + data.stops.reduce((a, b) => a + (b.spentFuel > 0 ? b.spentFuel : 0), 0)
    fuelConsumption = calculateSpentFuel(spentFuel, d, withFuelUsed)
  } else if (data.route && data.route.length > 1 && data.route[0].attributes.fuelUsed) {
    fuelConsumption = data.route[data.route.length - 1].attributes.fuelUsed - data.route[0].attributes.fuelUsed
  } else if (data.summary) {
    fuelConsumption = data.summary.spentFuel
  }
  return fuelConsumption > 0 ? fuelConsumption : 0
}

function calculateSpentFuel (value, device, withFuelUsed) {
  if (!value) { return value }

  if (device.attributes.xpert) {
    return withFuelUsed ? value : (value * device.attributes.fuel_tank_capacity) / 100
  }

  return value
}

function useOdooFuelData (d, route) {
  return route && route.length && !route[0].attributes.fuel && d.attributes.odooId
}

exports.calculateFuelDiff = calculateFuelDiff
exports.getRefuelingLiters = getRefuelingLiters
exports.calculateConsumption = calculateConsumption
exports.useOdooFuelData = useOdooFuelData
